<!-- modal-confirmation-sms.component.html -->
<app-page-header title="Confirmação de conta" subtitle="Informe o seu e-mail cadastrado" [headerFlexWrap]="false">
  <div class="container-button-close">
    @if (!data?.required) {
      <button type="button" class="btn-close" aria-label="Close" mat-dialog-close></button>
    }
  </div>
</app-page-header>
<mat-dialog-content>
  <div class="alert alert-info">
    Você receberá o código de confirmação no seu <b>e-mail</b> e <b>telefone</b> cadastrado por SMS e Whatsapp.
  </div>
  @if (!isCodeSent) {
    <form [formGroup]="emailForm" (ngSubmit)="onSendCode()">
      <div class="mb-3 mt-3">
        <label for="email" class="form-label">Informe o email da conta</label>
        <input type="email" class="form-control" id="email" formControlName="email" />
        @if (emailForm.get("email")?.invalid && emailForm.get("email")?.touched) {
          <div class="invalid-feedback">O email é obrigatório e deve ser válido.</div>
        }
        @if (emailForm.value.activationMethod === "sms") {
          <small class="text-warning"> O código será enviado para o celular vinculado ao e-mail informado. </small>
        }
      </div>
      <app-button type="submit" [disabled]="!this.emailForm.valid">
        {{ isCodeSent ? "Reenviar" : "Enviar" }} código
      </app-button>
    </form>
  }

  @if (isCodeSent) {
    <div class="code-form">
      <p>O código de ativação foi enviado por e-mail, SMS e Whatsapp.</p>
      <p>Digite o código abaixo recebido.</p>

      <p-inputOtp [(ngModel)]="code" [length]="6" [integerOnly]="true" [invalid]="!code || code.length < 6" />

      <app-button (btnClick)="onVerifyCode()">Verificar Código</app-button>

      <app-button [disabled]="isTimerActive" (btnClick)="cancelSentCode()"> Reenviar Código </app-button>
      @if (isTimerActive) {
        <p>
          Não recebeu o código? Aguarde <strong>{{ timer }}</strong> segundos para reenviar o código.
        </p>
      }
    </div>
  }
</mat-dialog-content>
